// extracted by mini-css-extract-plugin
export default {"inputWithLabel":"XhhdNsV7yu09M_W09MiV","label":"ZAEOFLWxxItjVSm5IlE7","input":"Ui1Eqw4aNNftrvSoN_kR"};